import React, { useState } from "react";
import useStyles from "../styles";
import config from "../../../config";

// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import InputComponent from "../../partner/components/inputComponent";
import { CircularProgress } from "@material-ui/core";
import Modal from "../../modals/Modal";

export default function AddSupplier() {
    const expressions = {
        usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
        nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
        password: /^.{4,12}$/, // 4 a 12 digitos.
        email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        numbers: /^[0-9]*$/, // 7 a 14 numeros.
        texto: /^[a-zA-Z0-9 ]{1,500}$/, // Letras
        textNumberAndSymbols: /^[a-zA-ZÀ-ÿ\sS&%'#+-@"!¡¿?()0-9._]+$/i
    }

    const classes = useStyles();

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [name, setName] = useState({ text: '', valid: null });
    const [phone, setPhone] = useState({ text: '', valid: null });
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const closeModalLogin = e => {
        setShowModal(false);
    }

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoading(true);

        if (name.valid === 'true') {
            const newJob = {
                name: name.text, phone: phone.text
            };

            const response = await fetch(baseUrl + "createSupplier", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
                body: JSON.stringify(newJob)
            });
            const json = await response.json();

            if (json.message == "Ok") {
                setName({ text: '', valid: null });
                setPhone({ text: '', valid: null });
            } else {
                if (json.message == "Access is denied") {
                    setShowModal(true);
                }
            }

            setIsLoading(false);
        } else {
            setIsLoading(false);
        }
    }

    return (
        <div>
            {showModal ? (
                <Modal
                    isOpen={showModal}
                    closeModal={closeModalLogin}
                />
            ) : (
                <></>
            )}
            <PageTitle title="Configuración" />

            <div className={classes.divAddPage} >
                <div className={classes.divTitle}>
                    <label className={classes.titleStyle}>Agregar proveedor</label>
                </div>

                <div className={classes.divColumn} >
                    <InputComponent
                        text={name}
                        setPartnerCode={setName}
                        type="text"
                        label="Nombre"
                        name="name"
                        regularExpression={expressions.textNumberAndSymbols}
                        placeholder="Nombre"
                    />

                    <InputComponent
                        text={phone}
                        setPartnerCode={setPhone}
                        type="text"
                        label="Teléfono"
                        name="phone"
                        regularExpression={expressions.numbers}
                        placeholder="Teléfono"
                    />
                </div>

                <div className={classes.divButton}>
                    {isLoading ? (
                        <div className={classes.loginLoader} >
                            <CircularProgress size={26} />
                        </div>

                    ) : (
                        <button
                            className={name.valid === 'true' ?
                                classes.enableButton : classes.disableButton}
                            onClick={onSubmit}
                        >Agregar</button>
                    )}
                </div>
            </div>
        </div>
    );
}
